export default {"src":"/_next/static/media/customer-service.4dc6f8d3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};